<template>
  <div class="wrap" v-loading="allLoading">
    <div>
      <div class="main-wrap order-details">
        <!-- 吸顶：公告 + 导航（含总金额）固定不随内容滚动；top 动态等于固定头部 .head-wrap 的高度，z-index 低于头部 -->
        <div class="detail-sticky-head" ref="stickyHead" :style="{ top: headHeight + 'px' }">
        <!-- 公告 -->
        <div class="announcement" v-if="$store.state.bannerInfo.notice && $store.state.bannerInfo.notice.trim()">
          <span class="text">{{$store.state.bannerInfo.notice}}</span>
          <div class="left-line"></div>
          <div class="right-line"></div>
        </div>
        <!-- 导航 -->
        <div class="order-navigation-wrap">
          <div class="order-navigation">
            <router-link
              class="text"
              to="/catalogue"
            >{{L.home}}</router-link>
            <span class="line">/</span>
            <router-link
              class="text"
              to="/myOrders"
            >{{L.myOrder}}</router-link>
            <span class="line">/</span>
            <router-link
              class="text text2"
              :to="{path:'/orderDetail', query:{ebsorderNo:$route.query.ebsorderNo}}"
            >{{$route.query.ebsorderNo}}</router-link>
          </div>
          <div v-if="publicInfo.isMixOrder" class="total-amount">
            <div>
              <span>Total Amount:</span>
              <span class="amount-value">{{formatMoney(publicInfo.mixOrderAmount)}}</span>
            </div>
            <div>{{publicInfo.mixOrderItemCount}} Order Items</div>
            <div></div>
          </div>
        </div>
        </div>

        <!-- 蓝猫 DS订单 -->
        <div v-if="publicInfo.haveDsOrder">
          <div class="order-detail-title">
            <div class="title-text-wrap">
              <div class="title-text">C&I {{L.order}} {{orderInfo.orderNo}}</div>
              <div class="transverse-line-wrap">
                <span class="transverse-line"></span>
              </div>
            </div>
          </div>
          <!-- 基本信息 -->
          <div class="basic-information">
            <div class="info-left order-detail-left">
              <!-- 客户信息 -->
              <div class="customer">
                <div class="title">
                  {{L.customerInfo}}
                </div>
                <div class="content">
                  <!-- sold to设置成false,暂时不显示 -->
                  <div class="line" v-if="false">
                    <div class="left">
                      <!-- 售至 -->
                      <span class="left-text1">{{L.soldTo}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.soldTo}}</span>
                    </div>
                  </div>
                  <div class="line">
                    <div class="left">
                      <!-- 发货至 -->
                      <span class="left-text1">{{L.shipTo}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.shipTo}}</span>
                    </div>
                  </div>
                  <div class="line">
                    <div class="left">
                      <!-- 开票至 -->
                      <span class="left-text1">{{L.billTo}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.billTo}}</span>
                    </div>
                  </div>
                  <!-- payer设置成false,暂时不显示 -->
                  <div class="line" v-if="false">
                    <div class="left">
                      <!-- 付款方 -->
                      <span class="left-text1">{{L.payer}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.payer}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 采购订单信息 -->
              <div class="customer">
                <div class="title">
                  <!-- 采购订单信息 -->
                  {{L.purchaseOrderInfo}}
                </div>
                <div class="content">
                  <div class="line">
                    <div class="left">
                      <!-- 交货条款 -->
                      <span class="left-text1">{{L.incoterms}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.incoTerms}}</span>
                    </div>
                  </div>
                  <div class="line">
                    <div class="left">
                      <!-- 付款条款 -->
                      <span class="left-text1">{{L.paymentTerms}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.paymentTerms}}</span>
                    </div>
                  </div>
                  <div class="line">
                    <div class="left">
                      <!-- 采购订单编号 -->
                      <span class="left-text1">{{L.PONumber}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.poNo}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- comment -->
              <div class="customer" v-if="orderInfo.comment">
                <div class="title">
                  Order Remarks
                </div>
                <div class="content">
                  <div class="line">
                    <div class="left">
                      <!-- 交货条款 -->
                      <span class="left-text1">Comment:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{orderInfo.comment}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-right order-detail-right">
              <!-- 订单汇总 -->
              <div class="order-summary">{{L.orderSummary}}</div>
              <div class="content">
                <div class="detail-info">
                  <!-- 订单状态 -->
                  <span class="text-left">{{L.orderStatus}}:</span>
                  <span class="text-right">{{orderInfo.orderStatus}}</span>
                </div>
                <div class="detail-info">
                  <!-- 订购日期 -->
                  <span class="text-left">{{L.orderDate}}:</span>
                  <span class="text-right">{{orderInfo.orderDate}}</span>
                </div>
                <div class="detail-info">
                  <!-- 订单来源 -->
                  <span class="text-left">{{L.placedVia}}:</span>
                  <span class="text-right">{{orderInfo.placedVia}}</span>
                </div>
                <div class="detail-info">
                  <!-- 下单方式 -->
                  <span class="text-left">{{L.placedBy}}:</span>
                  <span class="text-right text-placed-by">{{orderInfo.placedBy}}</span>
                </div>
              </div>        
              <div class="total-price">
                <div class="price-left">
                  <!-- 不含税总金额 -->
                  <div class="total">{{L.orderTotalAmount}}</div>
                  <!-- 个产品项 -->
                  <div class="item">{{orderInfo.itemCount}} {{L.orderltems}}</div>
                </div>
                <template v-if="$store.state.userInfo.accountRules && $store.state.userInfo.accountRules.includes('SP')">
                  <div class="price-right">{{formatMoney(orderInfo.totalPrice,orderInfo.currency)}}</div>
                </template>
              </div>
              <!-- 订单确认书(PDF) -->
              <div 
                class="btn-order-confirm" 
                :class="{'active-order':orderInfo.fileLocation && ($store.state.userInfo.accountRules && $store.state.userInfo.accountRules.includes('SP'))}" 
                @click="orderConfirmation"
              >{{L.orderConfirmationBook}}</div>
              <!-- 再次订购 -->
              <div class="re-order" @click="reOrder">{{L.reOrder}}</div>
            </div>
          </div>
          <!-- 产品概述 -->
          <div class="product-overview">
            <!-- 大标题 -->
            <div class="title">
              <!-- 订单详情 -->
              <span class="text">{{L.productOverview}}</span>
              <!-- 个产品项 -->
              <span class="quantity">{{orderInfo.itemCount}} {{L.orderltems}}</span>
            </div>
            <!-- 一大行 -->
            <div class="line" v-for="item in orderList" :key="item.lineId">
              <!-- 内容标题 -->
              <div class="line-title">
                <div class="title-left"></div>
                <div class="title-right">
                  <!-- 预计到货日期 -->
                  <div class="date">{{L.deliveryDateEstimate}}:</div>
                  <!-- 数量 -->
                  <div class="quantity">{{L.quantity}}:</div>
                  <div class="price"></div>
                </div>      
              </div>
              <!-- 主内容 -->
              <div class="main-content">
                <!-- 左边的 -->
                <div class="left">
                  <div class="info">
                    <div class="text">
                      <div class="text1">
                        <span v-if="item.canJump!=1" class="span1" href="javascript:;" @click="handleSkuName" v-html="item.productName"></span>
                        <a v-if="item.canJump==1" class="span1" :href="detailUrl(1,item.eanCode)" v-html="item.productName"></a>
                      </div>
                      <!-- <div class="text2">{{item.eanOrIc}} {{item.productNo}}</div> -->
                      <div class="text2" v-for="(item2,i2) in item.productRelationShowVoList" :key="i2">
                        <span :class="{'text2-active':i2==0}">{{item2.label}} {{item2.productNo}}</span>
                      </div>
                      <!-- quote No. -->
                      <!-- 隐藏quote -->
                      <div class="text2" v-if="item.quoteNumber">
                        <span>ERP Quote ID: </span>
                        <a class="quote-no" :href="'/#/quotesDetail?erpQuoteId='+item.quoteNumber">{{item.quoteNumber}}</a>
                      </div>
                      <!-- 需求的交货日期 -->
                      <div class="text2">{{L.requestedDeliveryDate}}: {{formatDate(item.requestDate)}}</div>
                    </div>
                  </div>
                </div>
                <!-- 右边的一行 -->
                <div class="right">
                  <div class="right-line">
                    <!-- 基本内容 -->
                    <div class="basic-info">
                      <div class="date">
                        <span class="iconfont icon-date">&#xe807;</span>
                        <span class="text-date">{{formatDate(item.estimateDate)}}</span>
                      </div>
                      <div class="quantity">
                        {{item.quantity}}
                      </div>
                      <div class="price">
                        <template v-if="$store.state.userInfo.accountRules && $store.state.userInfo.accountRules.includes('SP')">
                          <div class="left-price">
                            <div class="price-num">{{formatMoney(item.lineAmount,orderInfo.currency)}}</div>
                            <div class="carton-box">({{formatMoney(item.linePrice,orderInfo.currency)}} {{L.per}} {{item.lineUnit}})</div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <!-- 装箱内容 -->
                    <div class="carton-box-remark" v-if="item.ifVisible==1">
                      <div class="line-title" v-for="item2,i in item.qtyMsg" :key="i">
                        <div class="date"></div>
                        <div class="quantity">{{item2}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 下载那一行 -->
              <div class="download-bottom">
                <div class="download">
                  <!-- 交货单据 -->
                  <div class="delivery-note" v-if="item.deliverNoteFileLocation" >
                    <div class="delivery-note-inner">
                      <span class="iconfont iconfont-pdf">&#xe60a;</span>
                      <span class="text delivery-note-text" @click="handleDelivery(item,1)">{{L.deliveryDocument}}</span>
                      <el-tooltip 
                        popper-class="delivery-tip" 
                        effect="dark"
                        placement="top"
                      >
                        <div slot="content">
                          <div>DN Number: {{item.deliveryNoteNumber}}</div>
                          <div v-for="item in item.dnPackagingSpecificationsList" :key="item">{{item}}</div>
                        </div>
                        <span class="iconfont icon-info">&#xed50;</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <!-- carrierTrackingType是B的话，说明只有一个链接 -->
                  <a class="delivery-note text" v-if="item.carrierTrackingType=='B'" :href="item.carrierTrackingLink" target="_blank">
                    <span class="iconfont iconfont-pdf">&#xe621;</span>
                    <span>{{L.carrierTrackingLink}}</span>
                  </a>
                  <!-- carrierTrackingType是C的话，说明多个链接 -->
                  <div class="delivery-note text" v-show="item.carrierTrackingType=='C'" target="_blank">
                    <div class="text-icon" @click="handleShowTrackingLink(item)">
                      <span class="iconfont iconfont-pdf">&#xe621;</span>
                      <span>{{L.carrierTrackingLink}}</span>
                    </div>
                    <div class="tracking-wrap" v-show="item.showTrackingLink">
                      <CarrierTrackingLink ref="CarrierTrackingLink" @closeCarrierLink="closeCarrierLink"/>
                    </div>
                  </div>
                  <a
                    v-if="item.inveoiceType=='A'"
                    class="text"
                    :href="'/#/invoiceDetail?invoiceHeaderId='+item.invoiceId+'&invoiceNo='+item.invoiceNumber" 
                  >{{L.invocie}} {{item.invoiceNumber}}</a>
                  <a
                    v-if="item.inveoiceType=='B'"
                    class="text"
                    :href="'/#/creditNotesDetail?noteId='+item.creditNoteNumber" 
                  >Credit {{item.creditNoteNumber}}</a>
                  <a
                    v-if="item.inveoiceType=='C'"
                    class="text"
                    :href="'/#/debitNotesDetail?noteId='+item.debitNoteNumber" 
                  >Debit {{item.debitNoteNumber}}</a>
                  <!-- 发票单据 -->
                  <!-- <span class="text" v-if="item.invoiceFileLocation && ($store.state.userInfo.accountRules && $store.state.userInfo.accountRules.includes('SP'))" @click="handleDelivery(item,2)">{{L.invoiceDocument}}</span> -->
                </div>
                <div class="status">
                  <span class="status-text">{{item.lineStatus}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分割线 联合订单才展示 -->
        <div class="segment-line" v-if="publicInfo.isMixOrder"></div>

        <!-- 蓝猫 LED订单 -->
        <div v-if="publicInfo.haveLedOrder">
          <div class="order-detail-title">
            <div class="title-text-wrap">
              <div class="title-text">S&O {{L.order}} {{ledOrderInfo.orderNo}}</div>
              <div class="transverse-line-wrap">
                <span class="transverse-line"></span>
              </div>
            </div>
          </div>
          <!-- 基本信息 -->
          <div class="basic-information">
            <div class="info-left order-detail-left">
              <!-- 客户信息 -->
              <div class="customer">
                <div class="title">{{L.customerInfo}}</div>
                <div class="content">
                  <div class="line">
                    <div class="left">
                      <span class="left-text1">{{L.dealerAbbreviation}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{ledOrderInfo.dealerShortName}}</span>
                    </div>
                  </div>
                  <div class="line">
                    <div class="left">
                      <span class="left-text1">{{L.salesman}}:</span>
                    </div>
                    <div class="right">
                      <span class="right-text1">{{ledOrderInfo.salesName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="info-right order-detail-right">
              <!-- 订单汇总 -->
              <div class="order-summary">{{L.orderSummary}}</div>
              <div class="content">
                <div class="detail-info">
                  <!-- 订单状态 -->
                  <span class="text-left">{{L.orderStatus}}:</span>
                  <span class="text-right">{{ledOrderInfo.orderStatus}}</span>
                </div>
                <div class="detail-info">
                  <!-- 订购日期 -->
                  <span class="text-left">{{L.orderDate}}:</span>
                  <span class="text-right">{{ledOrderInfo.orderDate}}</span>
                </div>
                <div class="detail-info">
                  <!-- 订单来源 -->
                  <span class="text-left">{{L.placedVia}}:</span>
                  <span class="text-right">{{ledOrderInfo.placedVia}}</span>
                </div>
              </div>        
              <div class="total-price">
                <div class="price-left">
                  <!-- 含税总金额 -->
                  <div class="total">{{L.taxTotalAmount}}</div>
                  <!-- 个产品项 -->
                  <div class="item">{{ledOrderInfo.itemCount}} {{L.orderltems}}</div>
                </div>
                <template>
                  <div class="price-right">{{formatMoney(ledOrderInfo.totalPrice,ledOrderInfo.currency)}}</div>
                </template>
              </div>
              <!-- <div class="tip" v-if="contractListInProgress.includes(contractStatus)">Tip: Contract signing in progress.</div> -->
              <!-- LED的一些按钮 -->
              <div  class="active-order-led" @click="previewLedContract(0)" v-if="ledOrderInfo.operationCodeList.includes('PVC')">
                <span>{{L.previewContract}}</span>
                <span @click.stop="previewLedContract(1)" class="iconfont icon-preview">&#xec86;</span>
              </div>
              <div class="active-order-led" v-if="ledOrderInfo.operationCodeList.includes('SFC')" @click="showVerifyPop">{{L.signCustomer}}</div>
              <div class="active-order-led" v-if="ledOrderInfo.operationCodeList.includes('DSC')" @click="downloadContract(0)">
                <span>{{L.downloadSignedContract}}</span>
                <span @click.stop="downloadContract(1)" class="iconfont icon-preview">&#xec86;</span>
              </div>
              <div class="re-order" v-if="ledOrderInfo.operationCodeList.includes('OCA')" @click="reRoderLed">{{L.reOrder}}</div>
            </div>
          </div>
          <!-- 产品概述 -->
          <div class="product-overview product-overview-led">
            <!-- 大标题 -->
            <div class="title">
              <!-- 订单详情 -->
              <span class="text">{{L.productOverview}}</span>
              <!-- 个产品项 -->
              <span class="quantity">{{ledOrderInfo.itemCount}} {{L.orderltems}}</span>
            </div>
            <!-- 一大行 -->
            <div class="line line-led" v-for="item in ledOrderList" :key="item.lineId">
              <div class="info-top">
                <div class="left">
                  <div class="text">
                    <div class="text1"><span>{{item.skuName}}</span></div>
                    <div class="text2">
                      <span class="text2-title">{{L.productNo}}:</span>
                      <span class="text2-content">{{item.skuId}}</span>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="request">{{L.requestedDeliveryDate}}:</div>
                  <div class="quantity">{{L.quantity}}:</div>
                  <div class="price">{{L.unitPrice}}:</div>
                  <div class="total-price"></div>
                </div>
              </div>
              <!-- 主内容 -->
              <div class="main-content">
                <!-- 左边的 -->
                <div class="left">
                  <div class="led-title-wrap">
                    <span class="inp-title">{{L.terminalCustomer}}:</span>
                    <span class="led-context">{{item.finalCustomerName}}</span>
                  </div>
                  <div class="led-title-wrap">
                    <span class="inp-title">{{L.contactPerson}}:</span>
                    <span class="led-context">{{item.shipContact}}</span>
                  </div>
                  <div class="led-title-wrap">
                    <span class="inp-title">{{L.phone}}:</span>
                    <span class="led-context">{{item.shipPhone}}</span>
                  </div>
                  <div class="led-title-wrap">
                    <span class="inp-title">{{L.address}}:</span>
                    <span class="led-context">{{item.shipAddress}}</span>
                  </div>
                  <div class="led-title-wrap">
                    <span class="inp-title">{{L.invoicingName}}:</span>
                    <span class="led-context">{{item.invokeName}}</span>
                  </div>
                  <div class="led-title-wrap">
                    <span class="inp-title">{{L.warrantyPeriod}}:</span>
                    <span class="led-context">{{item.warranty}}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="led-right-one">
                    <div class="request">
                      <span class="iconfont icon-date">&#xe807;</span>
                      <span class="text-date">{{formatDate(item.deliveryDate)}}</span>
                    </div>
                    <div class="quantity">{{item.skuCount}}</div>
                    <div class="price">{{item.skuPrice}}</div>
                    <div class="total-price">{{formatMoney(item.skuAmount,item.currency)}}</div>
                  </div>
                  <div class="led-right-two">
                    <div class="delivery-date">
                      <div class="reponse-date">{{L.reponseDeliveryDate}}:</div>
                      <div class="reponse-date-value">
                        <span class="text">{{item.responseDeliveryDate}}</span>
                      </div>
                    </div>
                    <div class="more-remark">
                      <div class="line1-remark">
                        <span class="iconfont icon-arrow" :class="{'icon-active':item.showCarton}" @click="foldLedMaterial(item)">&#xe66c;</span>
                        <span class="cus-remark" @click="foldLedMaterial(item)">{{L.customerRemark}}</span>
                      </div>
                      <transition
                          @enter="enter"
                          @afterEnter="afterEnter"
                          @leave="leave"
                          @afterLeave="afterLeave"
                        >
                        <div v-if="item.showCarton" class="more-animatin">
                          <div class="line2-remark">
                            <span class="remark-title">{{L.materialCode}}:</span>
                            <span class="remark-text">{{item.materialCode}}</span>
                          </div>
                          <div class="line2-remark">
                            <span class="remark-title">{{L.terminalContractNo}}:</span>
                            <span class="remark-text">{{item.terminalContract}}</span>
                          </div>
                          <div class="line2-remark">
                            <span class="remark-title">{{L.processNo}}:</span>
                            <span class="remark-text">{{item.processOrder}}</span>
                          </div>
                          <div class="line2-remark">
                            <span class="remark-title">{{L.boxRemark}}:</span>
                            <span class="remark-text">{{item.boxRemark}}</span>
                          </div>
                        </div>
                      </transition>
                    </div>
                    <div class="led-status">
                      <span class="status">{{item.lineStatus}}</span>
                    </div>  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AddCartErr ref="AddCartErr" />
    <AddCartResult ref="AddCartResult" />
    <VerifyContractLED ref="VerifyContractLED" :ledOrderNo="ledOrderInfo.orderNo" @finishContract="finishContract"/>
    <Refresh ref="Refresh" @closeWindow="closeWindow" />
  </div>
</template>

<script>
import {postAction} from '@/api/tool'
import {api_sign_contract_status,api_order_detail,api_quick_order,api_order_confirm_download,api_order_preview_contract_LED,api_re_order_LED,api_sign_order} from '@/api/api'
import { getAction,downFileGet } from '../../api/tool'
import Vue from 'vue'
import AddCartErr from '@/components/AddCartErr'
import AddCartResult from '@/components/AddCartResult'
import CarrierTrackingLink from '@/components/CarrierTrackingLink'
import VerifyContractLED from '@/components/VerifyContractLED'
import Refresh from './Refresh'



export default {
  name:'OrderDetail',
  components:{
    AddCartErr,
    AddCartResult,
    CarrierTrackingLink,
    VerifyContractLED,
    Refresh
  },
  data(){
    return {
      contractListInProgress:['INIT','UPLOADING','UPLOADED','INITIATED','SIGNING','COMPLETING'],
      contractStatus:'',
      publicInfo:{}, //公共信息
      // ouList:['OU-PL','OU-NL','OU-UK','OU-SK'], //这些OU的要展示公告
      orderInfo:{}, //LED的信息
      orderList:[], //LED的列表
      ledOrderInfo:{}, //LED的信息
      ledOrderList:[], //LED的列表
      headHeight:0, //固定头部 .head-wrap 的高度，作为本页吸顶头(公告+导航)的 top
    }
  },
  methods:{
    /* 测量固定头部 .head-wrap 高度，作为本页吸顶头(公告+导航)的 top，使其正好贴在头部下方（参考商机详情页 Detail/index.vue） */
    handleResize(){
      this.$nextTick(()=>{
        let headEl = document.querySelector('.head-wrap')
        this.headHeight = headEl ? headEl.offsetHeight : 0
      })
    },
    /* 用 ResizeObserver 盯住吸顶头 .head-wrap：其高度随 logo 图片、用户信息/权限菜单/语言包等异步数据到位而变，
       这些 XHR 不触发 window load，只靠 resize/load 会在头部最终长高前就定死 top，导致吸顶头与头部错位/重叠 */
    observeHeadResize(){
      if(typeof ResizeObserver === 'undefined'){ return }
      let headEl = document.querySelector('.head-wrap')
      if(!headEl){ return }
      this.headResizeObserver = new ResizeObserver(()=>{ this.handleResize() })
      this.headResizeObserver.observe(headEl)
    },
    /* 再下一单-LED */
    reRoderLed(){
      let params={
        ledOrderNo:this.ledOrderInfo.orderNo
      }
      this.allLoading=true
      postAction(api_re_order_LED,params).then(res=>{
        this.allLoading=false
        this.getCartCount()
        //0说明全部成功
        if(res.errFlag==0){
          this.$refs.AddCartResult.open(res.errFlag)
        //1说明部分成功,2说明失败
        }else{
          this.$refs.AddCartResult.open(res.errFlag,res.errList)
        }
      }).catch(res=>{
        this.allLoading=false
        this.$message.error(res.msg)
      })
    },
    /* 折叠备注信息 */
    foldLedMaterial(item){
      this.ledOrderList.forEach((val,i)=>{
        if(item.lineDetailId==val.lineDetailId){
          val.showCarton=!item.showCarton
          this.$set(this.ledOrderList,i,val) //触发渲染
        }
      })
    },
    getSignContractStatus(){
      this.allLoading=true
      let params = {
        ledOrderNo:this.ledOrderInfo.orderNo
      }
      postAction(api_sign_contract_status,params).then(res=>{
        this.allLoading=false
        this.contractStatus = res.status
        this.getOrderDetail()
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 展示验证码的弹窗 */
    showVerifyPop(){
      let params = {
        ledOrderNo:this.ledOrderInfo.orderNo
      }
      this.allLoading=true
      postAction(api_sign_order,params).then(res=>{
        this.allLoading=false
        if(res.queryFailed || res.status=='FAILED'){
          this.$message.error(res.message)
        }else{
          this.$refs.Refresh.open()
          window.open(res.signUrl)
        }
      }).catch(()=>{
        this.allLoading=false
      })
    },
    closeWindow(){
      this.getSignContractStatus()
    },
    /* 合同签完了，刷新下页面 */
    finishContract(){
      this.getOrderDetail()
    },
    /* 下载合同 */
    downloadContract(flag){
      let params = {
        filezIds:this.ledOrderInfo.fileLocation
      }
      if(!params.filezIds){
        return
      }
      this.getLocationAndDownload(params,flag)
    },
    /* 预览LED合同 1预览 0下载*/
    previewLedContract(flag){
      let params = {
        ledOrderNo:this.ledOrderInfo.orderNo
      }
      this.allLoading=true
      postAction(api_order_preview_contract_LED,params).then(res=>{
        this.allLoading=false
        let url='/'+res.contractFileUrl.split(Vue.config.YUNPAN_URL)[1]
        downFileGet(url).then(res=>{
          this.allLoading=false
          this.downloadFile(res,flag)
        })
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 如果不是EAN的，点击skuName，报错提示 */
    handleSkuName(){
      this.$message.warning(this.L.sorryResult)
    },
    /* 获取order详情数据 */
    getOrderDetail(){
      let params={
        orderNo:this.$route.query.ebsorderNo,
        orderBu:this.$route.query.orderBu,
        relOrderDsNo:this.$route.query.relOrderDsNo,
        relOrderLedNo:this.$route.query.relOrderLedNo
      }
      this.allLoading=true
      postAction(api_order_detail,params).then(res=>{
        this.allLoading=false
        this.publicInfo=res

        if(res.haveDsOrder){
          this.orderInfo=res.dsOrderDetail
          this.orderList=res.dsOrderDetail.orderItems
        }
        if(res.haveLedOrder){
          this.ledOrderInfo=res.ledOrderDetail
          this.ledOrderList=res.ledOrderDetail.orderDetailLineList || {}
        }
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 展示tracking link的弹窗 */
    handleShowTrackingLink(item){
      this.orderList.forEach((val,i)=>{
        if(val.lineId==item.lineId){
          val.showTrackingLink=true
          this.$set(this.orderList,i,val) //触发渲染
          this.$refs.CarrierTrackingLink[i].setNowProductItem(val) //打开whishlist对话框
        }
      })
    },
    /* 关闭tracking link的弹窗 */
    closeCarrierLink(nowItem){
      this.orderList.forEach((val,i)=>{
        if(val.lineId==nowItem.lineId){
          val.showTrackingLink=false
          this.$set(this.orderList,i,val) //触发渲染
        }
      })
    },
    /* 再下一单,这里调快速下单的接口 */
    reOrder(){
      let str = ''
      this.orderList.forEach((val)=>{
        str=str + val.productNo + ' ' + val.quantity + '\n'
      })
      let params={
        quickContent:str
      }
      this.allLoading=true
      postAction(api_quick_order,params).then(res=>{
        this.allLoading=false
        this.getCartCount()
        //0说明全部成功
        if(res.errFlag==0){
          this.$refs.AddCartResult.open(res.errFlag)
        //1说明部分成功,2说明失败
        }else{
          this.$refs.AddCartResult.open(res.errFlag,res.errList)
        }
      }).catch(res=>{
        this.allLoading=false
        this.$message.error(res.msg)
      })
    },
    /* 从后端获取文件链接的数组,再下载文件到本地 1预览 0下载*/
    getLocationAndDownload(params,flag){
      this.allLoading=true
      getAction(api_order_confirm_download,params).then(res=>{
        res.forEach((val)=>{
          let url='/'+val.split(Vue.config.YUNPAN_URL)[1]
          url=url.replace('PDF?','pdf?')
          downFileGet(url).then(res=>{
            this.allLoading=false
            this.downloadFile(res,flag)
          })
        })
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 订单确认书 */
    orderConfirmation(){
      let params = {
        filezIds:this.orderInfo.fileLocation
      }
      if(!params.filezIds){
        return
      }
      if(!this.$store.state.userInfo.accountRules.includes('SP')){
        return
      }
      this.getLocationAndDownload(params,1)
    },
    /* Delivery Document & Invoice Document,pdf */
    handleDelivery(item,flag){
      let params = {
        filezIds:flag==1?item.deliverNoteFileLocation:item.invoiceFileLocation
      }
      if(!params.filezIds){
        return
      }
      this.getLocationAndDownload(params,1)
    }
  },
  mounted(){
    this.getOrderDetail()
    //吸顶头(公告+导航)的 top 需等于固定头部高度：算一次 + 监听 resize/load + ResizeObserver 兜住头部异步变高
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('load', this.handleResize)
    this.observeHeadResize()
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.handleResize)
    if(this.headResizeObserver){
      this.headResizeObserver.disconnect()
      this.headResizeObserver = null
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../public/css/public.less');
@import url('./index.less');
</style>

